<ng-template #modal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">
      {{ isReadOnlyMode ? 'Motivo do cancelamento' : ('Cancelar ' + (idsTrips.length > 1 ? idsTrips.length + ' viagens' : 'viagem')) }}
    </h5>
    <button type="button" class="close" aria-label="Close" [disabled]="isProcessing" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-footer sticky-footer">
    <form *ngIf="!isReadOnlyMode" id="justification" [formGroup]="formGroup">
      <div class="row justify-content-between">
        <div class="col-9">
          <app-custom-input
            *ngIf="!isManagerCancellation"
            [formGroup]="formGroup"
            controlName="justification"
            type="text"
            label="Justificativa"
            maxLength="100"
            (enterEvent)="onSubmit()">
          </app-custom-input>
          <div *ngIf="isManagerCancellation" class="form-label-group">
            <div class="input-group mb-3">
              <select
                id="input-justification"
                class="form-control"
                formControlName="justification"
                [attr.disabled]="isProcessing ? '' : null">
                <option [ngValue]="null">- Selecione -</option>
                <option *ngFor="let reason of managerCancellationReasons" [ngValue]="reason.value">
                  {{ reason.text }}
                </option>
              </select>
              <label for="input-justification">Justificativa</label>
            </div>
          </div>
        </div>
        <div class="col-2">
          <a class="btn btn-danger btn-sm btn-fill" [class.disabled]="isProcessing" (click)="onSubmit()">
            {{ idsTrips.length > 1 ? 'Cancelar todas' : 'Salvar' }}
          </a>
        </div>
      </div>

      <div *ngIf="isProcessing" class="processing-box">
        <span class="spinner-border spinner-border-sm text-primary me-2" role="status" aria-hidden="true"></span>
        Processando cancelamento, não feche ou saia da página...
      </div>
    </form>

    <div *ngIf="isReadOnlyMode" class="w-100">
      <div class="row justify-content-between">
        <div class="col-12">
          <label for="cancel-reason" class="form-label">Justificativa</label>
          <textarea
            id="cancel-reason"
            class="form-control"
            rows="3"
            readonly>{{ cancellationReason }}</textarea>
        </div>
      </div>
    </div>
  </div>
</ng-template>
